import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { colors, radius, s, ui } from '../styles/theme'
import { useIsMobile } from '../hooks/useViewport'
import SmartGeoKategori from './SmartGeoKategori'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const EN_AZ_KELIME = 25
const EN_FAZLA_KELIME = 140

function kelimeSayisi(t) {
  return String(t || '').split(/\s+/).filter(Boolean).length
}

function sadelestir(s) {
  return String(s == null ? '' : s)
    .replace(/[İIı]/g, 'i')
    .replace(/[Şş]/g, 's')
    .replace(/[Ğğ]/g, 'g')
    .replace(/[Üü]/g, 'u')
    .replace(/[Öö]/g, 'o')
    .replace(/[Çç]/g, 'c')
    .toLowerCase()
}

function urunKelimeleri(ad) {
  return Array.from(new Set(sadelestir(ad).split(/[^a-z0-9]+/).filter(k => k.length > 2 && !/^[0-9]+$/.test(k))))
}

function urunAdiGeciyorMu(cevap, urunAdi) {
  const kelimeler = urunKelimeleri(urunAdi)
  if (!kelimeler.length) return true
  const cevapKelimeleri = sadelestir(cevap).split(/[^a-z0-9]+/).filter(Boolean)
  const bulunan = kelimeler.filter(k => cevapKelimeleri.some(w => w.indexOf(k) === 0)).length
  return bulunan >= Math.max(1, Math.ceil(kelimeler.length * 0.6))
}

function satirDenetimi(f, urunAdi) {
  const sorunlar = []
  const soru = String(f.question || '').trim()
  const cevap = String(f.answer || '').trim()
  if (!soru) sorunlar.push('soru boş')
  else if (!/\?$/.test(soru)) sorunlar.push('soru işareti yok')
  const k = kelimeSayisi(cevap)
  if (!cevap) sorunlar.push('cevap boş')
  else if (k < EN_AZ_KELIME) sorunlar.push('cevap kısa (' + k + ' kelime)')
  else if (k > EN_FAZLA_KELIME) sorunlar.push('cevap uzun (' + k + ' kelime)')
  if (cevap && !urunAdiGeciyorMu(cevap, urunAdi)) {
    sorunlar.push('cevapta ürün adı geçmiyor')
  }
  return { kelime: k, sorunlar }
}

function Field({ label, hint, children }) {
  return (
    <div style={{ marginBottom: '14px' }}>
      <label style={s.labelNormal}>{label}</label>
      {children}
      {hint && <p style={{ fontSize: '11.5px', color: colors.textSecondary, margin: '4px 0 0' }}>{hint}</p>}
    </div>
  )
}

export default function SmartGeo() {
  const { selectedBrand } = useBrand()
  const mobil = useIsMobile()
  const token = localStorage.getItem('adminToken')
  const headers = { Authorization: token }

  const [mod, setMod] = useState('tek')
  const [q, setQ] = useState('')
  const [results, setResults] = useState([])
  const [searching, setSearching] = useState(false)
  const [product, setProduct] = useState(null)
  const [baslik, setBaslik] = useState('')
  const [faq, setFaq] = useState([])
  const [adet, setAdet] = useState(5)
  const [lastSent, setLastSent] = useState(null)
  const [hasBackup, setHasBackup] = useState(false)
  const [onizleme, setOnizleme] = useState(null)
  const [jsonldAcik, setJsonldAcik] = useState(false)
  const [busy, setBusy] = useState(false)
  const [uretiliyor, setUretiliyor] = useState(false)
  const [msg, setMsg] = useState(null)

  useEffect(() => { setProduct(null); setResults([]); setFaq([]); setOnizleme(null) }, [selectedBrand?.id]) // eslint-disable-line

  function flash(text, ok = true) { setMsg({ text, ok }); setTimeout(() => setMsg(null), 4000) }

  function search() {
    if (!selectedBrand || !q.trim()) return
    setSearching(true)
    axios.get(`${API}/admin/brands/${selectedBrand.id}/smart-geo/products`, { headers, params: { q } })
      .then(res => setResults(res.data.products || []))
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setSearching(false))
  }

  function pickProduct(p) {
    setProduct(p); setOnizleme(null)
    axios.get(`${API}/admin/brands/${selectedBrand.id}/smart-geo/${p.external_id}`, { headers })
      .then(res => {
        setFaq(Array.isArray(res.data.faq) ? res.data.faq : [])
        setBaslik(res.data.baslik || '')
        setLastSent(res.data.last_sent_at)
        setHasBackup(!!res.data.has_backup)
      })
      .catch(() => { setFaq([]); setBaslik('') })
  }

  function setSatir(i, key, value) { setFaq(l => l.map((f, j) => j === i ? { ...f, [key]: value } : f)) }
  function ekle() { setFaq(l => [...l, { question: '', answer: '' }]) }
  function sil(i) { setFaq(l => l.filter((_, j) => j !== i)) }
  function tasi(i, yon) {
    setFaq(l => {
      const a = [...l]; const j = i + yon
      if (j < 0 || j >= a.length) return l
      const t = a[i]; a[i] = a[j]; a[j] = t
      return a
    })
  }

  function yapayZeka() {
    if (faq.length && !window.confirm('Yapay zeka mevcut soru-cevapların yerine yenilerini yazacak. Devam edilsin mi?')) return
    setUretiliyor(true)
    axios.post(`${API}/admin/brands/${selectedBrand.id}/smart-geo/${product.external_id}/ai`, { adet }, { headers })
      .then(res => { setFaq(res.data.faq || []); setOnizleme(null); flash((res.data.faq || []).length + ' soru üretildi, yayına almadan önce kontrol edin') })
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setUretiliyor(false))
  }

  function kaydet() {
    setBusy(true)
    axios.put(`${API}/admin/brands/${selectedBrand.id}/smart-geo/${product.external_id}`, { faq, baslik }, { headers })
      .then(() => flash('Kaydedildi'))
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setBusy(false))
  }

  function onizle() {
    setBusy(true)
    axios.post(`${API}/admin/brands/${selectedBrand.id}/smart-geo/${product.external_id}/preview`, { faq, baslik }, { headers })
      .then(res => setOnizleme(res.data))
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setBusy(false))
  }

  function gonder() {
    if (!window.confirm('Soru-cevap bloğu ürünün “Açıklama” alanının sonuna eklenecek ve canlıda görünecek. Onaylıyor musunuz?')) return
    setBusy(true)
    axios.post(`${API}/admin/brands/${selectedBrand.id}/smart-geo/${product.external_id}/send`, { faq, baslik }, { headers })
      .then(res => { flash(res.data.soru + ' soru ürüne gönderildi'); setLastSent(new Date().toISOString()); setHasBackup(true) })
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setBusy(false))
  }

  function geriAl() {
    if (!window.confirm('Soru-cevap bloğu ürün açıklamasından kaldırılacak. Onaylıyor musunuz?')) return
    setBusy(true)
    axios.post(`${API}/admin/brands/${selectedBrand.id}/smart-geo/${product.external_id}/revert`, {}, { headers })
      .then(() => { flash('Blok kaldırıldı, açıklama eski haline döndü'); setLastSent(null) })
      .catch(e => flash(e.response?.data?.error || e.message, false))
      .finally(() => setBusy(false))
  }

  if (!selectedBrand) return <div style={ui.notice}>Önce bir marka seçin.</div>

  const ta = { ...s.input, minHeight: '96px', resize: 'vertical', fontFamily: 'inherit', lineHeight: 1.55 }
  const dolu = faq.filter(f => String(f.question || '').trim() && String(f.answer || '').trim())
  const denetimler = faq.map(f => satirDenetimi(f, product && product.name))
  const sorunluAdet = denetimler.filter(d => d.sorunlar.length).length
  const gonderilebilir = dolu.length > 0 && sorunluAdet === 0

  return (
    <div>
      <div style={{ ...s.flexBetween, marginBottom: '18px', flexWrap: 'wrap', gap: '10px' }}>
        <div style={{ minWidth: 0 }}>
          <h1 style={s.pageTitle}>Smart GEO</h1>
          <p style={s.pageSubtitle}>Ürün açıklamasının altına yapay zekanın alıntılayabileceği soru-cevap bloğu ve arama motoru künyesi ekler</p>
        </div>
        <div style={ui.segmented}>
          <button style={ui.segmentedBtn(mod === 'tek')} onClick={() => setMod('tek')}>Tek ürün</button>
          <button style={ui.segmentedBtn(mod === 'kategori')} onClick={() => setMod('kategori')}>Kategori</button>
        </div>
      </div>

      {mod === 'kategori' && <SmartGeoKategori />}

      {mod === 'tek' && (
        <>
      {msg && <div style={{ ...(msg.ok ? s.alertSuccess : s.alertDanger), marginBottom: '16px' }}>{msg.text}</div>}

      <div style={{ ...s.card, marginBottom: '16px' }}>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
          <input style={{ ...s.input, maxWidth: '360px', flex: '1 1 220px', minWidth: 0 }} placeholder="Ürün adı veya kodu ara" value={q}
            onChange={e => setQ(e.target.value)} onKeyDown={e => e.key === 'Enter' && search()} />
          <button style={s.btnSecondary} onClick={search} disabled={searching}>{searching ? 'Aranıyor…' : 'Ara'}</button>
          {product && <span className="sx-break" style={{ fontSize: '13px', color: colors.textSecondary }}>Seçili: <b>{product.name}</b></span>}
        </div>
        {results.length > 0 && !product && (
          <div style={{ marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {results.map(p => (
              <div key={p.external_id} style={{ ...s.cardSm, display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap', cursor: 'pointer' }} onClick={() => pickProduct(p)}>
                {p.image_url && <img src={p.image_url} alt="" style={{ width: '38px', height: '38px', objectFit: 'cover', borderRadius: radius.sm, flexShrink: 0 }} />}
                <div className="sx-break" style={{ flex: '1 1 160px', minWidth: 0 }}>
                  <div style={{ fontSize: '13px', fontWeight: 600 }}>{p.name}</div>
                  <div style={{ fontSize: '11.5px', color: colors.textMuted, fontFamily: 'monospace' }}>{p.product_code}</div>
                </div>
                {p.has_geo && <span style={ui.chip}>Yayında</span>}
                <button style={ui.btnSm}>Seç →</button>
              </div>
            ))}
          </div>
        )}
        {results.length === 0 && !product && q && !searching && (
          <p style={{ ...ui.emptyText, margin: '12px 0 0' }}>Bu aramaya uygun ürün bulunamadı.</p>
        )}
      </div>

      {product && (
        <>
          <div style={{ ...s.flexBetween, marginBottom: '12px', flexWrap: 'wrap', gap: '8px' }}>
            <div className="sx-break" style={{ fontSize: '13px', color: colors.textSecondary, minWidth: 0 }}>
              {lastSent ? `Yayında · son gönderim: ${new Date(lastSent).toLocaleString('tr-TR')}` : 'Henüz gönderilmedi'}
              {product.product_url && <> · <a href={product.product_url} target="_blank" rel="noreferrer" style={{ color: colors.primary }}>Ürünü aç</a></>}
            </div>
            <button style={ui.btnQuiet} onClick={() => { setProduct(null); setResults([]); setOnizleme(null) }}>Başka ürün seç</button>
          </div>

          <div style={{ ...s.card, marginBottom: '16px' }}>
            <div className="sx-grid-panel" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px', alignItems: 'end' }}>
              <Field label="Blok başlığı" hint="Boş bırakılırsa “Sıkça Sorulan Sorular” kullanılır.">
                <input style={s.input} value={baslik} onChange={e => setBaslik(e.target.value)} placeholder="Sıkça Sorulan Sorular" />
              </Field>
              <Field label="Yapay zeka kaç soru yazsın?">
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                  <select style={{ ...s.select, maxWidth: '90px' }} value={adet} onChange={e => setAdet(parseInt(e.target.value))}>
                    {[3, 4, 5, 6, 7, 8].map(n => <option key={n} value={n}>{n}</option>)}
                  </select>
                  <button style={s.btnSecondary} onClick={yapayZeka} disabled={uretiliyor || busy}>
                    {uretiliyor ? 'Yazılıyor…' : 'Yapay zeka ile yaz'}
                  </button>
                </div>
              </Field>
            </div>
            <p style={{ fontSize: '11.5px', color: colors.textMuted, margin: '2px 0 0' }}>
              Yapay zeka yalnızca ürünün kendi açıklamasından yararlanır; üretilen metin siz “Gönder” demeden yayına çıkmaz.
            </p>
          </div>

          <div style={{ ...s.card, marginBottom: '16px' }}>
            <div style={{ ...s.flexBetween, marginBottom: '12px', flexWrap: 'wrap', gap: '8px' }}>
              <h3 style={{ ...s.sectionTitle, margin: 0 }}>Soru ve cevaplar</h3>
              <span style={{ fontSize: '11.5px', color: sorunluAdet ? colors.warning : colors.textMuted }}>
                {dolu.length} geçerli soru{sorunluAdet ? ` · ${sorunluAdet} soruda düzeltilecek nokta var` : dolu.length ? ' · tümü kriterlere uygun' : ''}
              </span>
            </div>

            {faq.length === 0 && (
              <p style={{ ...ui.emptyText, margin: '0 0 12px' }}>
                Henüz soru yok. Elle ekleyebilir ya da yukarıdaki “Yapay zeka ile yaz” düğmesini kullanabilirsiniz.
              </p>
            )}

            {faq.map((f, i) => {
              const d = denetimler[i]
              return (
                <div key={i} style={{ ...s.cardFlat, padding: '14px', marginBottom: '10px' }}>
                  <div style={{ ...s.flexBetween, marginBottom: '8px', flexWrap: 'wrap', gap: '8px' }}>
                    <span style={{ fontSize: '12px', fontWeight: 600, color: colors.textSecondary }}>Soru {i + 1}</span>
                    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                      <button style={{ ...ui.btnSm, padding: '4px 9px' }} onClick={() => tasi(i, -1)} disabled={i === 0}>↑</button>
                      <button style={{ ...ui.btnSm, padding: '4px 9px' }} onClick={() => tasi(i, 1)} disabled={i === faq.length - 1}>↓</button>
                      <button style={{ ...ui.btnDangerQuiet, padding: '4px 9px' }} onClick={() => sil(i)}>Sil</button>
                    </div>
                  </div>
                  <Field label="Soru" hint="Gerçek bir soru cümlesi olmalı ve soru işaretiyle bitmeli.">
                    <input style={s.input} value={f.question || ''} onChange={e => setSatir(i, 'question', e.target.value)}
                      placeholder="ör. Bu ürün bulaşık makinesinde yıkanabilir mi?" />
                  </Field>
                  <Field label="Cevap" hint={`İlk cümlede doğrudan cevabı verin, ürün adını cevabın içinde kullanın. ${EN_AZ_KELIME}-${EN_FAZLA_KELIME} kelime önerilir.`}>
                    <textarea style={ta} value={f.answer || ''} onChange={e => setSatir(i, 'answer', e.target.value)} />
                  </Field>
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                    <span style={{ fontSize: '11.5px', color: colors.textMuted, fontVariantNumeric: 'tabular-nums' }}>{d.kelime} kelime</span>
                    {d.sorunlar.map((x, j) => (
                      <span key={j} style={{ ...s.badgeWarning, fontSize: '11px' }}>{x}</span>
                    ))}
                    {!d.sorunlar.length && <span style={{ ...s.badgeSuccess, fontSize: '11px' }}>kriterlere uygun</span>}
                  </div>
                </div>
              )
            })}
            <button style={s.btnSecondary} onClick={ekle}>+ Soru ekle</button>
          </div>

          <div style={{ ...s.card, marginBottom: '16px', display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
            <button style={s.btnSecondary} onClick={onizle} disabled={busy || !dolu.length}>Önizle</button>
            <button style={s.btnSecondary} onClick={kaydet} disabled={busy}>Kaydet</button>
            {!gonderilebilir && dolu.length > 0 && (
              <span style={{ fontSize: '12px', color: colors.warning }}>Gönderebilmek için uyarıların giderilmesi gerekir.</span>
            )}
            <div className="sx-wrap" style={{ marginLeft: 'auto', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              {hasBackup && lastSent && <button style={ui.btnDangerQuiet} onClick={geriAl} disabled={busy}>Bloğu kaldır</button>}
              <button style={s.btnPrimary} onClick={gonder} disabled={busy || !gonderilebilir}>Gönder</button>
            </div>
          </div>

          {onizleme && (
            <div style={s.card}>
              <h3 style={{ ...s.sectionTitle, marginBottom: '12px' }}>Önizleme — müşterinin göreceği blok</h3>
              <div className="sx-scroll-x">
                <iframe title="Smart GEO Önizleme"
                  srcDoc={`<!doctype html><html><head><meta charset="utf-8"><style>body{margin:0;padding:24px;background:#fff;font-family:-apple-system,Segoe UI,Roboto,Arial,sans-serif}</style></head><body>${onizleme.gorunen || ''}</body></html>`}
                  style={{ display: 'block', width: '100%', minWidth: mobil ? '320px' : undefined, height: mobil ? '440px' : '620px', border: `1px solid ${colors.border}`, borderRadius: radius.md, background: colors.bgCard }} />
              </div>

              <div style={{ ...s.flexBetween, margin: '16px 0 0', flexWrap: 'wrap', gap: '8px' }}>
                <div>
                  <h3 style={{ ...s.sectionTitle, margin: 0 }}>Arama motoru künyesi</h3>
                  <p style={{ fontSize: '11.5px', color: colors.textMuted, margin: '2px 0 0' }}>
                    Sayfaya gömülen yapısal veri. Google ve yapay zeka araçları soru-cevapları buradan okur.
                  </p>
                </div>
                <button style={ui.btnQuiet} onClick={() => setJsonldAcik(v => !v)}>{jsonldAcik ? 'Gizle' : 'Kodu göster'}</button>
              </div>
              {jsonldAcik && (
                <pre style={{
                  marginTop: '10px', padding: '12px', background: colors.bgPage, border: `1px solid ${colors.border}`,
                  borderRadius: radius.md, fontSize: '11.5px', lineHeight: 1.6, overflowX: 'auto', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                }}>{onizleme.jsonld || '(künye üretilmedi)'}</pre>
              )}
            </div>
          )}
        </>
      )}
        </>
      )}
    </div>
  )
}
